import { Button } from 'components/Button';
import { TextInput } from 'components/Inputs';
import { SwitchDoubleValue } from 'components/Inputs/SwitchDoubleValue';
import { ContainedModal } from 'components/molecules';
import { useTreatmentConsultation } from 'context';
import React, { useEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import {
  ICreateTreatmentConsultation,
  TreatmentConsultationTypesEnum,
} from 'types';

import { Box, InputLabel, Stack } from '@mui/material';

export const SaveTreatmentConsultationModal: React.FC = () => {
  const {
    saveTreatmentConsultationModal,
    saveTreatmentPrescriptionModal,
    saveConsultation,
    treatmentOnGoingId,
    loading,
    currentTreatmentConsultation,
  } = useTreatmentConsultation();

  const form = useForm<ICreateTreatmentConsultation>({
    defaultValues: {
      consultType: 'teleorientation',
      anamnesis: '',
      diagnosis: '',
      orientation: '',
      treatment: '',
      ...currentTreatmentConsultation,
      treatmentId: treatmentOnGoingId,
    },
  });

  const consultType = useWatch({ control: form.control, name: 'consultType' });

  const handleCreatePrescription = () => {
    saveConsultation(form.getValues()).then(() => {
      saveTreatmentPrescriptionModal.onOpen();
    });
  };

  useEffect(() => {
    if (!saveTreatmentConsultationModal.isOpen) {
      form.reset({
        consultType: 'teleorientation',
        anamnesis: '',
        diagnosis: '',
        orientation: '',
        treatment: '',
        ...currentTreatmentConsultation,
        treatmentId: treatmentOnGoingId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    saveTreatmentConsultationModal.isOpen,
    treatmentOnGoingId,
    currentTreatmentConsultation,
  ]);

  return (
    <ContainedModal
      isOpen={saveTreatmentConsultationModal.isOpen}
      onClose={saveTreatmentConsultationModal.onClose}
      title={
        currentTreatmentConsultation?.id ? 'EDITAR CONSULTA' : 'NOVA CONSULTA'
      }
      //  sx={{ overflowY: 'scroll' }}
    >
      <FormProvider {...form}>
        <Stack px={3} mt={4} spacing={4}>
          <Box>
            <InputLabel
              sx={{ color: '#757575', fontWeight: 500, mb: 1, ml: 1 }}
            >
              MOTIVO/ANAMNESE*
            </InputLabel>
            <TextInput
              required
              disabled={loading}
              rules={{
                required: 'Motivo/Anamnese não pode ficar em branco',
              }}
              fullWidth
              multiline
              minRows={2}
              name="anamnesis"
              id="anamnesis"
              placeholder="DESCREVA O MOTIVO/ANAMNESE"
            />
          </Box>

          <Box>
            <SwitchDoubleValue
              disabled={true}
              // Disabled white teleconsultation is not ready to use
              name="consultType"
              id="consultType"
              leftlabel="Teleorientação"
              leftValue={TreatmentConsultationTypesEnum.teleorientation}
              rightLabel="Teleconsulta"
              rightValue={TreatmentConsultationTypesEnum.teleconsultation}
            />
          </Box>

          {consultType === TreatmentConsultationTypesEnum.teleconsultation ? (
            <>
              <Box>
                <InputLabel
                  sx={{ color: '#757575', fontWeight: 500, mb: 1, ml: 1 }}
                >
                  DIAGNÓSTICO
                </InputLabel>
                <TextInput
                  disabled={loading}
                  fullWidth
                  multiline
                  minRows={2}
                  name="diagnosis"
                  id="diagnosis"
                  placeholder="DESCREVA O DIAGNÓSTICO"
                />
              </Box>

              <Box>
                <InputLabel
                  sx={{ color: '#757575', fontWeight: 500, mb: 1, ml: 1 }}
                >
                  TRATAMENTO
                </InputLabel>
                <TextInput
                  disabled={loading}
                  fullWidth
                  multiline
                  minRows={2}
                  name="treatment"
                  id="treatment"
                  placeholder="DESCREVA O TRATAMENTO"
                />
              </Box>
            </>
          ) : (
            <Box key="orientation">
              <InputLabel
                sx={{ color: '#757575', fontWeight: 500, mb: 1, ml: 1 }}
              >
                ORIENTAÇÕES*
              </InputLabel>
              <TextInput
                disabled={loading}
                required
                rules={{
                  required: 'Orientações não pode ficar em branco',
                }}
                fullWidth
                multiline
                minRows={2}
                name="orientation"
                id="orientation"
                placeholder="DESCREVA QUAIS AS ORIENTAÇÕES"
              />
            </Box>
          )}

          <Stack spacing={2} direction="row" justifyContent="flex-end">
            {consultType === TreatmentConsultationTypesEnum.teleconsultation ? (
              <>
                <Button
                  disabled={loading}
                  variant="text"
                  onClick={saveTreatmentConsultationModal.onClose}
                >
                  CANCELAR
                </Button>

                <Button
                  variant="outlined"
                  onClick={form.handleSubmit(saveConsultation)}
                  loading={loading}
                  disabled={loading}
                >
                  SALVAR
                </Button>

                <Button disabled={loading} onClick={handleCreatePrescription}>
                  {currentTreatmentConsultation?.prescription?.length
                    ? 'EDITAR PRESCRIÇÃO'
                    : 'REALIZAR PRESCRIÇÃO'}
                </Button>
              </>
            ) : (
              <>
                <Button
                  disabled={loading}
                  variant="outlined"
                  onClick={saveTreatmentConsultationModal.onClose}
                >
                  CANCELAR
                </Button>

                <Button
                  onClick={form.handleSubmit(saveConsultation)}
                  loading={loading}
                  disabled={loading}
                >
                  SALVAR
                </Button>
              </>
            )}
          </Stack>
        </Stack>
      </FormProvider>
    </ContainedModal>
  );
};
